import Head from 'next/head';
import { FAQ_QUESTIONS } from '../../src/constants/faq';
import FAQPage from '../../src/containers/FAQPage';
// const HomeownersLandingPage = dynamic(() => import('../../src/containers/HomeownersLandingPage'));

const FAQQuestion = (props) => {
  const { question } = props;

  if (!question) return null;
  const getPageTitle = () => {
    return `${question.title} | Zorba`;
  };
  const getPageDescription = () => {
    return question.desc;
  };
  return (
    <>
      <Head>
        <title>{getPageTitle()}</title>
        <meta key="og:title" property="og:title" content={getPageTitle()} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={getPageTitle()}
        />
        <meta
          key="description"
          name="description"
          content={getPageDescription()}
        />
        <meta
          key="og:description"
          property="og:description"
          content={getPageDescription()}
        />
        <meta
          key="keywords"
          name="keywords"
          content={`off-market properties,investment properties for sale,fsbo,distressed properties`}
        />
      </Head>
      <FAQPage selectedQuestion={question} />
      {/* <HomeownersLandingPage pageName="investorLandingPage" /> */}
    </>
  );
};

FAQQuestion.getInitialProps = async ({
  store,
  isServer,
  pathname,
  query,
  ctx,
}) => {
  const { questionKey } = query;
  if (!questionKey) return {};

  // const placeResponse = await getPlaceDetails(placeQuery);
  const question = FAQ_QUESTIONS[questionKey];
  if (!question) {
    return {
      redirect: {
        destination: '/',
        permanent: true,
      },
    };
  }

  return {
    question,
  };
};

export default FAQQuestion;
